import SidePanel from "../../Components/SidePanel";
import TopBar from "../../Components/TopBar";
import Styles from "./MockDashboard.module.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { Package_List } from "../../Action/PacakgeAction";
import { useDispatch, useSelector } from "react-redux";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6";
import Slider from "react-slick";
import PackageCard from "../../Components/PackageCard";
import Styles2 from "../Home/Home.module.css";
import Loading from "../../Components/Loading";
import Enroll from "../Home/Enroll";
import MenuBarRight from "../Material/MenuBarRight";
import CourseDropDown from "../Components/CrouseDropDown";
import { listMockTest } from "../../Action/mockTestAction";
import ReactHelmet from "../../Components/ReactHelmet";

export default function MockTestDashboard() {
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const [CourseId, setCourseId] = useState("");
  const [selectCourseId, setSelectCourseId] = useState("");
  const Mobile_Screen = window.innerWidth;
  const [OpenMenuBar, setOpenMenuBar] = useState(false);
  const [EnrollActive, setEnrollActive] = useState(false);
  const { loading: loadingPack, PackageRec } = useSelector(
    (s) => s.Package_List_Reducer
  );
  const { PackageData, loading: LoadingPackDet } = useSelector(
    (s) => s.SelectStudentPackageReducer
  );
  const { MockTestRec } = useSelector((s) => s.mockTestListAllRecReducer);
  const dispatch = useDispatch();
  const BrowsePackageRef = useRef();

  const BrowsePacakgesettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow:
      Mobile_Screen <= 480
        ? 1
        : Mobile_Screen <= 780
        ? PackageRec?.length >= 2
          ? 2
          : 1
        : PackageRec?.length >= 2
        ? 2
        : PackageRec?.length === 2
        ? 2
        : 1,
    slidesToScroll: 1,
  };

  const get_Packages = useCallback(() => {
    dispatch(Package_List({ page_size: 10, page_no: 1 }));
  }, [dispatch]);

  useEffect(() => {
    get_Packages();
  }, [get_Packages]);

  useEffect(() => {
    dispatch(listMockTest(PackageData?._id));
  }, [PackageData, dispatch]);

  const OpenBarClick = (index) => {
    if (OpenMenuBar === index) {
      setOpenMenuBar(false);
    } else {
      setOpenMenuBar(index);
    }
  };

  return (
    <div className={Styles.Dashboard}>
      <ReactHelmet title={"Mock Test"} description={""} />

      {/* SidePanel */}

      {Mobile_Screen >= 780 ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Mock Test"
        />
      ) : (
        ""
      )}

      {Mobile_Screen <= 480 && SidebarOpen ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Mock Test"
        />
      ) : (
        ""
      )}

      {loadingPack ? <Loading /> : ""}

      {EnrollActive ? (
        <Enroll
          setEnrollActive={setEnrollActive}
          Package_Id={EnrollActive}
          courseId={CourseId}
        />
      ) : (
        ""
      )}
      {/* Middle Section */}
      {!SidebarOpen ? (
        <section className={Styles.MiddleSection}>
          <div>
            <TopBar
              SetSideBarOpen={SetSideBarOpen}
              SidebarOpen={SidebarOpen}
              PageName={"Mock Test"}
            />
          </div>

          {MockTestRec?.length ? (
            ""
          ) : (
            <div className={Styles.OnlineClassTopSection}>
              <div>
                <h3 style={{ textAlign: "center", fontWeight: "500" }}>
                  Please buy the package to unlock this section.
                </h3>
              </div>
            </div>
          )}

          {MockTestRec?.length ? (
            <section style={{ paddingBottom: "60px", padding: "10px 25px " }}>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    '<h2 class="ql-align-center">Overview of the IELTS Listening Test</h2><ul><li>The IELTS Listening test&nbsp;lasts around 30 minutes.</li><li>You will have 10 minutes at the end to transfer your answers to the answer sheet provided.</li><li>It is divided into 4 parts. The questions get progressively more difficult as the test goes on.</li><li>There are 40 questions in total. Each question carries 1 mark.</li><li>Timing is key. For each part, you will have time to look at the questions before the recording begins and you will have time to check your answers at the end.</li><li>Listening is exactly the same for Academic and General Training.</li></ul><h4><strong>Section 1</strong></h4><p>You will hear a conversation between two people and it is almost always someone making an appointment or making a booking of some kind (e.g. making a hotel reservation or hiring a car). The questions are normally gap-fill questions in which you have to listen to the information and complete a form or sentence.</p><h4><strong>Section 2</strong></h4><p>You will hear someone talking by themselves about a non-academic subject (e.g. TV or radio presenter).</p><h4><strong>Section 3</strong></h4><p>Switches to an academic context and it will always be more than one person discussing something (e.g. an academic paper or assignment).</p><h4><strong>Section 4</strong></h4><p>&nbsp;Is normally an academic lecture and you will hear one person (normally the lecturer or professor) talking for an extended period of time.</p><p>You will be given a short amount of time (approximately 30 seconds) between each section and you should use this time to look at the questions coming up.</p><p>You will hear the recordings only once.</p><p>There are several different types of question and each requires a different strategy so you should familiarise yourself with all of them. They include:</p><ul><li>&nbsp;<strong>Form/note/table completion</strong></li><li><strong>&nbsp;Labeling a diagram or map</strong></li><li><strong>&nbsp;Sentence Completion</strong></li><li><strong>&nbsp;Short Answers</strong></li><li><strong>&nbsp;Multiple Choice</strong></li><li><strong>&nbsp;Summary Completion&nbsp;</strong></li><li><strong>&nbsp;Matching And Classifying</strong></li></ul><p><br></p>',
                }}
              ></div>
            </section>
          ) : (
            <section style={{ background: "#f4f9ff", paddingBottom: "60px" }}>
              <div style={{ margin: "30px" }}>
                <div className={Styles.Browse_Package_Section}>
                  <div>
                    <h1 className={Styles.Heading}>
                      <span className="Font_Rajdhani">Browse Courses </span>
                    </h1>
                    {/* <p>
                    In this free interactive webinar, our IELTS expert will help
                    us be ready to answer
                    <br /> a range of common questions types for Part 1 of the
                    Speaking Test.
                  </p> */}
                  </div>
                  <div className={Styles.Browse_Package_Scroller}>
                    <div onClick={() => BrowsePackageRef?.current?.slickPrev()}>
                      <FaCircleArrowLeft />
                    </div>
                    <div onClick={() => BrowsePackageRef?.current?.slickNext()}>
                      <FaCircleArrowRight />
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ margin: "0 30px" }}>
                <Slider
                  ref={BrowsePackageRef}
                  style={{ width: "100%" }}
                  {...BrowsePacakgesettings}
                >
                  {PackageRec?.map((el, i) => (
                    <div key={el._id}>
                      <PackageCard
                        setEnrollActive={setEnrollActive}
                        EnrollActive={EnrollActive}
                        setCourseId={setCourseId}
                        el={el}
                        Styles={Styles2}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </section>
          )}
        </section>
      ) : (
        " "
      )}

      {Mobile_Screen <= 480 ? (
        ""
      ) : (
        <div className={Styles.MainContainer}>
          <div className={Styles.PackageSelect}>
            <select
              value={selectCourseId}
              onChange={(e) => setSelectCourseId(e.target.value)}
            >
              <option value="">select Course</option>
              <CourseDropDown />
            </select>
          </div>
          <div className={Styles.RightSidePanel}>
            {MockTestRec?.map((ev, index) => (
              <MenuBarRight
                Styles={Styles}
                OpenMenuBar={OpenMenuBar}
                index={index}
                OpenBarClick={OpenBarClick}
                Details={ev}
              />
            ))}
          </div>
        </div>
      )}

      {/* Right Section  */}
    </div>
  );
}
